import { downloadDocumentFileById } from '../services/documentService';
import ConsoleHelper from './consoleHelper';

export const downloadDocumentFile = async (id: number, fileName: string, loadingCallback: (b: boolean) => void, fileType?: string) => {
  loadingCallback(true);
  try {
    const response = await downloadDocumentFileById(id);
    let blob = response.data as Blob;

    const mime = blob?.type || fileType || 'application/octet-stream';
    if (mime && mime !== blob.type) {
      blob = new Blob([blob], { type: mime });
    }

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName || 'download';
    a.click();
    a.remove();

    setTimeout(() => URL.revokeObjectURL(url), 0);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    try {
      const serverBlob = err?.response?.data;
      if (serverBlob instanceof Blob) {
        const text = await serverBlob.text();
        ConsoleHelper.error('Download error (server):', text);
      } else {
        ConsoleHelper.error('Download error:', err);
      }
    } catch {
      ConsoleHelper.error('Download error:', err);
    }
  } finally {
    loadingCallback(false);
  }
};
